const EmptyBox = () => (
  <svg
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <circle cx="100" cy="100" r="100" fill="#A3CBF5" />
    <mask
      id="mask0_4779_190696"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="200"
      height="200"
    >
      <circle cx="100" cy="100" r="100" fill="#E8D4FF" />
    </mask>
    <g mask="url(#mask0_4779_190696)">
      <path
        d="M103.155 116.084C108.425 104.742 114.902 88.5159 99.4879 82.6722C80.2202 75.3677 99.6302 118.514 109.949 89.4378C118.479 65.4015 102.905 53.5138 84.7207 43.75"
        stroke="#1E5A99"
        strokeLinecap="round"
        strokeDasharray="5 5"
      />
      <path d="M41.7602 114.375H113.023V205H41.7602V114.375Z" fill="#FDC65E" />
      <path d="M113.023 114.375H156.913V205H113.023V114.375Z" fill="#FCB226" />
      <path
        d="M41.7602 114.375H113.023L83.7628 140.335H12.5L41.7602 114.375Z"
        fill="#FFF8EB"
      />
      <path
        d="M157.186 114.375H113.023L127.852 137.975H174.375L157.186 114.375Z"
        fill="#FFF8EB"
      />
      <mask
        id="mask1_4779_190696"
        maskUnits="userSpaceOnUse"
        x="54"
        y="18"
        width="34"
        height="34"
      >
        <circle
          cx="71.1259"
          cy="35.0417"
          r="16.1868"
          transform="rotate(-55.0268 71.1259 35.0417)"
          fill="#A3CBF5"
        />
      </mask>
      <g mask="url(#mask1_4779_190696)">
        <path
          d="M65.7876 44.006C64.8304 41.4483 66.1359 38.5469 68.6989 37.5357L70.2136 41.583C71.1708 44.1406 69.8653 47.042 67.3023 48.0533L65.7876 44.006Z"
          fill="white"
        />
        <path
          d="M77.7104 26.9615C74.9796 26.9394 72.7017 29.1606 72.6307 31.915L76.9519 31.95C79.6828 31.9722 81.9606 29.751 82.0317 26.9966L77.7104 26.9615Z"
          fill="white"
        />
        <rect
          x="60.5684"
          y="36.5454"
          width="14.5681"
          height="18.2101"
          rx="4"
          transform="rotate(-55.0268 60.5684 36.5454)"
          fill="white"
        />
      </g>
    </g>
  </svg>
);
export { EmptyBox };
